import React from "react";
import { cn } from "@/lib/utils";

const publicUrl = process.env.PUBLIC_URL || "";

/**
 * Renders the HppyFx wordmark for light or dark UI surfaces.
 * @param {"default" | "inverted"} variant — `inverted` for dark or purple backgrounds
 */
export default function HppyfxMark({ variant = "default", className, alt = "HppyFx" }) {
  const src =
    variant === "inverted"
      ? `${publicUrl}/HppyfxInverted.svg`
      : `${publicUrl}/HppyfxLogo.svg`;
  return (
    <img
      src={src}
      alt={alt}
      className={cn("h-9 w-auto object-contain object-left", className)}
    />
  );
}
